import {
    Box,
    FormControl,
    Grid,
    InputLabel, MenuItem, TextField,
} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {ErrorComponent} from "../../../components/error/error.component";
import {BaseService} from "../../../services/base-service";
import {URLS} from "../../../services/app-urls";
import {toast} from "react-toastify";
import {Client} from "../../../models/basic/client";
import Select from "@mui/material/Select";
import DragAndDropFileComponent from "../../../components/dnd-file/dnd-file.component";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {enUS, ptBR} from "date-fns/locale";
import style from "./MonthDatePicker.module.css";
import {ImportAmortizationService} from "../../../services/import-amortization-service";


const AddImportNreCostsComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        dataSourceClient,
    } = props;

    const service = new ImportAmortizationService();
    const [selectedFile, setSelectedFile] = React.useState<File[] | undefined>(undefined);
    const [selectedClient, setSelectedClient] = React.useState<string | undefined>(undefined);

    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [month, setMonth] = useState<Date | null>(null);
    const [validEndDate, setValidEndDate] = useState<boolean>(true);
    const locale = translate.language == "pt" ? ptBR : enUS;

    useEffect(() => {
    }, []);

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append("client", selectedClient!);
        formData.append("report", selectedFile![0]);
        formData.append("period_initial", new Date(startDate!.toString()).toISOString().split("T")[0]);
        formData.append("period_final", new Date(endDate!.toString()).toISOString().split("T")[0]);
        formData.append("month", String(new Date(month!.toString()).getMonth() + 1));

        service.createFormData(formData).then(response => {
            toast.success(translate.t("successfully_registered"));
            setSelectedFile(undefined);
            setSelectedClient(undefined);
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    };

    const handleFileUpload = (files: File[]) => {
        setSelectedFile(files);
    };

    const handleStartDateChange = (date: any) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date: any) => {
        if (date == "Invalid Date") {
            setValidEndDate(false);
        } else if (!date) {
            setValidEndDate(false);
        } else {
            setValidEndDate(true);
        }
        setEndDate(date);
    };

    const handleMonthChange = (date: any) => {
        setMonth(date);
    }


    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                setSelectedFile(undefined);
                handleCloseDialog();
            }}
            title={"import_nre_costs"}
            colorButton={"primary"}
            labelButton={"import"}
            disableConfirm={
                isDisabled ||
                !selectedFile?.length ||
                !selectedClient ||
                !startDate ||
                !endDate ||
                !validEndDate ||
                !month
            }
            closeButtonText={"close"}
            handleConfirm={handleSubmit}>
            <Box>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <FormControl fullWidth>
                            <InputLabel>
                                {translate.t("client")}*
                            </InputLabel>
                            <Select
                                required
                                name="client"
                                label={translate.t("client")}
                                variant={"outlined"}
                                fullWidth
                                autoFocus={false}
                                value={selectedClient}
                                onChange={(event: any) => setSelectedClient(event.target.value)}
                            >
                                {dataSourceClient?.map((client: Client) => (
                                    <MenuItem key={client.id} value={client.id}>
                                        {client.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={12} container spacing={2} direction="row">
                        <Grid size={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                                <DatePicker
                                    views={['month']}
                                    openTo="month"
                                    label={translate.t("month")}
                                    value={month}
                                    onChange={handleMonthChange}
                                    inputRef={(props: any) => (
                                        <TextField
                                            {...props}
                                            required={true}
                                        />
                                    )}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                        },
                                        popper: {
                                            className: style.customDatePickerPopper,
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                                <DatePicker
                                    label={translate.t("start_date")}
                                    value={startDate}
                                    onChange={handleStartDateChange}
                                    inputRef={(props: any) => (
                                        <TextField
                                            {...props}
                                            required={true}
                                        />
                                    )}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                                <DatePicker
                                    label={translate.t("end_date")}
                                    value={endDate}
                                    onChange={handleEndDateChange}
                                    inputRef={(props: any) => (
                                        <TextField
                                            {...props}
                                            required={true}
                                        />
                                    )}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                        }
                                    }}
                                    minDate={startDate || undefined}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid  marginTop={3} size={12}>
                        <DragAndDropFileComponent onFileUpload={handleFileUpload} multiple={false} types={['xlsx']} maxSize={30}/>
                    </Grid>
                </Grid>
            </Box>
        </GenericDialog>
    )
}

export default AddImportNreCostsComponent;
